var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"row no-gutters",attrs:{"id":"home-k-feature"}},_vm._l((_vm.items),function(item,index){return _c('Item',{key:index,attrs:{"data":item,"idx":index}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }